"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flowbiteReact = require("flowbite-react");
var _jsxRuntime = require("react/jsx-runtime");
const Steps = _ref => {
  let {
    last_card_title,
    last_card_content,
    last_cardSecondaryBtnHref,
    last_cardSecondaryBtnText,
    title,
    obj,
    bg
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "stacked ",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
      className: "max-w-[934px] mb-10 sm:mb-14 block m-auto text-center",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "grid sm:gap-y-2 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-4",
      children: [obj.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "cardItem flex justify-center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flowbiteReact.Card, {
          className: `w-[283px] !h-[220px] port:text-center ${bg === "dark" ? "!bg-primaryDark text-white " : bg === "light" ? "!bg-darkSix" : "!bg-darkSix"}`,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "block port:m-auto",
            children: item.icon
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
            children: item.card_title
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: item.card_content
          })]
        })
      }, index)), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "lastStep flex justify-center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flowbiteReact.Card, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            className: "text-[30px] leading-9",
            children: last_card_title
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
            href: last_cardSecondaryBtnHref,
            className: "secondary-btn inline-flex items-center xl:!w-[180px]",
            children: last_cardSecondaryBtnText
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: last_card_content
          })]
        })
      })]
    })]
  });
};
var _default = Steps;
exports.default = _default;